<template>
  <div v-if="windowWidth > 0">
    <NuxtLayout name="default" class="font-roboto">
      <template #mostVisitedSlot>
        <ClassicNtpCommonMostVisitedAffinityTiles />
      </template>
      <template #newsSlot>
        <LazyClassicNtpCommonNews
          :first-row-ad-tile-position="firstRowAdTilePosition"
          :second-row-ad-tile-position="secondRowAdTilePosition"
          :third-row-ad-tile-position="thirdRowAdTilePosition"
          :ad-tile-position-increment="adTilePositionIncrement"
          :below-fold-ad-tile-position="belowFoldAdTilePosition"
          :with-newscatcher="true"
          :new-design="true"
          :has-below-fold-ad-unit="true"
        >
          <template #adsSlot="slotProps">
            <LazyClassicNtpCommonNtpBelowFoldAdUnit
              v-if="slotProps.position === belowFoldAdTilePosition"
              :tile-index="belowFoldAdTilePosition"
            />
            <DirectAdLoader
              v-else
              fallback="outbrain"
              only-show-directed-ad-in-position="1"
              :counter="slotProps.counter"
              :grid-position="slotProps.position"
              :widget-id="slotProps.widgetId"
            />
          </template>
        </LazyClassicNtpCommonNews>
      </template>
      <template #footerSlot>
        <LazyClassicNtpCommonFooter />
      </template>
    </NuxtLayout>
  </div>
</template>

<script setup>
  import { getAdTilePositions } from '~~/assets/js/adTilePositions'
  import DirectAdLoader from '~/components/classic/ntp/common/DirectAdLoader.vue'

  definePageMeta({
    layout: false,
    pageTransition: false,
  })

  const windowWidth = ref(0)

  const firstRowAdTilePosition = ref(3)
  const secondRowAdTilePosition = ref(8)
  const thirdRowAdTilePosition = ref(17)
  const adTilePositionIncrement = ref(8)
  const belowFoldAdTilePosition = ref(17)

  onMounted(() => {
    windowWidth.value = window.innerWidth
    if (windowWidth.value > 0) {
      updateAdTilePositions()
    }
    window.addEventListener('resize', () => {
      windowWidth.value = window.innerWidth
      updateAdTilePositions()
    })
  })

  onUnmounted(() => {
    window.removeEventListener('resize', () => {
      windowWidth.value = window.innerWidth
    })
  })

  const updateAdTilePositions = () => {
    const adTilesPositions = getAdTilePositions('Ads_V5', windowWidth.value)
    firstRowAdTilePosition.value = adTilesPositions.firstRowAdTilePosition
    secondRowAdTilePosition.value = adTilesPositions.secondRowAdTilePosition
    thirdRowAdTilePosition.value = adTilesPositions.thirdRowAdTilePosition
    adTilePositionIncrement.value = adTilesPositions.adTilePositionIncrement
    belowFoldAdTilePosition.value = adTilesPositions.belowFoldAdTilePosition
  }

  useHead({
    script: [
      {
        type: 'text/javascript',
        src: 'https://widgets.outbrain.com/outbrain.js',
        async: true,
      },
    ],
  })
</script>
